import path from 'ramda/src/path'
import { mnemonicIdKey, creatorDataKey } from 'root/src/shared/constants/keys'

export default path(['app', 'userData', creatorDataKey, mnemonicIdKey])
